<template>
  <div class="ForumResponseBodyText" :class="classList" :style="styleVars">
    <div class="ForumResponseBodyText__html">
      <ForumResponseBodyTextOutput
        :text="response.mentionProcessedText"
        :truncate="truncate"
        :lines="lines"
        :basic-mention="basicMention"
        :chat-id="response.chatId"
      />
    </div>
  </div>
</template>

<script>
import { ForumResponseModel } from '@/models/forum/forumResponse'
import ForumResponseBodyTextOutput from '@/components/pages/forum/response/body/text/ForumResponseBodyTextOutput.vue'

export default {
  name: 'ForumResponseBodyText',
  components: { ForumResponseBodyTextOutput },
  props: {
    response: { type: ForumResponseModel, required: true },
    highlights: { type: Array, default: () => [] },

    // NEW:
    truncate: { type: Boolean, default: false },
    lines: { type: [Number, String], default: null },
    basicMention: { type: Boolean, default: true }
  },
  data() {
    return {
      newHighlight: null,
      componentInstances: []
    }
  },
  computed: {
    classList() {
      const linesNum = Number(this.lines)
      return {
        [`${this.$options.name}_truncate`]: this.truncate && (!linesNum || linesNum === 1),
        [`${this.$options.name}_clamp`]: linesNum && linesNum > 1
      }
    },
    styleVars() {
      const linesNum = Number(this.lines)
      return linesNum && linesNum > 1 ? { '--frbt-clamp': linesNum } : null
    }
  }
}
</script>

<style scoped lang="scss">
.ForumResponseBodyText {
  $root: &;
  @apply break-words;

  &__html {
    #{$root}_truncate & {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    #{$root}_clamp & {
      display: -webkit-box;
      -webkit-line-clamp: var(--frbt-clamp, 2);
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  &.ForumResponseBodyText_clamp {
    ::v-deep > * {
      display: -webkit-box;
      -webkit-line-clamp: var(--frbt-clamp, 2);
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
</style>
